import { logger } from "@mwt/web-js-telemetry";

import { ALLOWED_LAUNCH_SOURCES } from "../../environments/environment";
/**
 * Ensures the launch source is from an expected entry point
 * returns input launch source if valid otherwise returns empty str
 * @param launchSource string value
 */
export function validateLaunchSource(launchSource: string): string {
  if (!ALLOWED_LAUNCH_SOURCES.includes(launchSource)) {
    logger.debug(
      `[getValidatedEndpoint] - endpoint passed is not a valid launch source - ${launchSource}`
    );
    return "";
  }
  return launchSource;
}
